"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadValue = void 0;
var utils_1 = require("./utils");
var getReadValue = function (_a) {
    var reading = _a.reading, registerId = _a.registerId, timeOfUseLabel = _a.timeOfUseLabel, meterNumOfDigits = _a.meterNumOfDigits;
    return reading.tiers
        .filter(function (tier) {
        return registerId
            ? tier.registerId === registerId
            : tier.timeOfUseLabel === timeOfUseLabel;
    })
        .map(function (tier) {
        return (0, utils_1.applyLeadingZeros)(meterNumOfDigits, Math.floor(tier.meterRegisterReading));
    })[0];
};
exports.getReadValue = getReadValue;
